import React, { useMemo } from 'react';
import { components } from 'react-select';
import Avatar from '../../../general/Avatar';
import Icon from '../../../general/Icon';
const MultiValueLabel = /*#__PURE__*/React.memo(props => {
  const label = useMemo(() => props.selectProps.showMediaInSelectedValues && (props.data.iconType || props.data.src) ? /*#__PURE__*/React.createElement("span", null, props.data.iconType && /*#__PURE__*/React.createElement(Icon, {
    name: props.data.iconType,
    color: props.data.iconColor || null,
    size: "medium"
  }), props.data.src && /*#__PURE__*/React.createElement(Avatar, {
    size: "tiny",
    src: props.data.src,
    placeholder: props.data.placeholder || '',
    alt: props.data.alt
  }), /*#__PURE__*/React.createElement("span", null, props.data.label)) : props.data.label, [props]);
  return components.MultiValueLabel && /*#__PURE__*/React.createElement(components.MultiValueLabel, props, label);
});
MultiValueLabel.displayName = 'MultiValueLabel';
export default MultiValueLabel;